import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getChargesFilteredData } from '../../services/chargesService';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();
    const toast = useToast({position: "top", duration: 3000, status: "success", });

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        ChargeName: ""      
      });

      const handleFilterCharges = (e) => {
        e.preventDefault();
    
        const filteredResult = data?.filter((item) => {
          const { ChargeName } = filterCriteria;
    
          let filterChargeName = true;
    
          if (ChargeName) {
            filterChargeName = item.ChargeName?.toLowerCase().includes(ChargeName.toLowerCase());
          }

          return  filterChargeName ;     

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getChargesFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.charges.charges_filter")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterCharges}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.charges.charge_name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.charges.charge_name")}
                name="ChargeName"
                value={filterCriteria.ChargeName}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    ChargeName: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
}
